import { VolumeUp } from "@mui/icons-material"
import { Tooltip } from "@mui/material"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { PRIMARY_BLUE, } from "utils/customizedTheme"

const AudioHeading = ({icon, title, hint = null, audio = null}) => {
    const { t } = useTranslation()

    const audioEl = useRef(new Audio(audio));

    return (
            <div className="small-student-heading">
                {icon && <div className="small-student-heading-icon"><img src={icon} /></div> }   
                <div className="small-student-heading-title">{title}</div>   
                { audio && <div className="small-student-heading-audio">
                    <Tooltip title={hint || t('dashboard.click-to-play')} placement='top'>
                        <VolumeUp sx={{ 
                            color: PRIMARY_BLUE, 
                            fontSize: '30px', 
                            position: 'relative', 
                            bottom: '-2px',
                            cursor: 'pointer'
                        }} onClick={() => {
                            const audio = audioEl.current;
                            audio.play();
                        }}/>
                    </Tooltip>
                </div>}
            </div>  
    )
}

export default AudioHeading
